import axios from "axios";
import authHeader from "./auth-header";

const API_URL = 'https://apialunorte.kairosmining.com/api/'
const API_URL2 = 'https://apikairos.kairosmining.com/api/'

// const getPublicContent = () => {
//   return axios.get(API_URL + "all");
// };

// const getDataN1 = (body,url) => {
//   return axios.post(API_URL + url, body, { headers: authHeader() }); 
// };

const getDataN2 = (body, url) => {
  return axios.post(API_URL2 + 'WallDisplay/'+ url, body, { headers: authHeader(), timeout: 5000 });
};

const getAlarms = (body, url) => {
  return axios.post(API_URL2 + 'dashboard/'+ url, body, { headers: authHeader(), timeout: 5000 });
};

// "/cioe/getDataN1"

// const getANDataN1 = (body,url) => {
//   return axios.post(API_URL + url, body, { headers: authHeader() });  //alunorte
// };

// "/alunorte/getANDataN1"

// const getDataAPC = (body) => {
//   return axios.post(API_URL + "/cioe/getDataAPC", body, { headers: authHeader() });
// };

// const getDataAPCGlobal = (body) => {
//   return axios.post(API_URL + "/cioe/getDataAPCGlobal", body, { headers: authHeader() });
// };


const exportedObject = {
  //getPublicContent,
  //getDataN1,
  getDataN2,
  getAlarms
  //getDataAPC,
  //getDataAPCGlobal
}

export default exportedObject